const AnimatedBubbleBackground = () => {
  return (
    <div className='fixed inset-0 -z-10 overflow-hidden'>
      <div className='bubble-tobermory absolute rounded-full' />
      <div className='bubble-moonlit-mauve absolute rounded-full' />
      <div className='glass-frame absolute inset-0' />
    </div>
  );
};

export default AnimatedBubbleBackground;
